<section class="clients">
  <div class="container">
    <p class="clients__label">{{ t().clients_label }}</p>
    <div class="clients__marquee">
      <div class="clients__track">
        @for (c of clients; track c) {
          <div class="client-logo">
            <span>{{ c }}</span>
          </div>
        }
        <!-- Duplicate for seamless loop -->
        @for (c of clients; track c + '_dup') {
          <div class="client-logo">
            <span>{{ c }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section" id="contact">
  <div class="container">
    <div class="cta-inner">
      <div class="cta-content">
        <h2>{{ t().cta_title }}</h2>
        <p>{{ t().cta_subtitle }}</p>
      </div>
      <div class="cta-form">
        <input type="text" [placeholder]="t().cta_name" />
        <input type="email" [placeholder]="t().cta_email" />
        <input type="text" [placeholder]="t().cta_company" />
        <select>
          <option value="">{{ t().cta_segment }}</option>
          <option>{{ t().cta_opt_mining }}</option>
          <option>{{ t().cta_opt_oil }}</option>
          <option>{{ t().cta_opt_steel }}</option>
          <option>{{ t().cta_opt_energy }}</option>
          <option>{{ t().cta_opt_other }}</option>
        </select>
        <button class="btn-primary" style="width: 100%; justify-content: center;">
          {{ t().cta_btn }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <p class="form-note">{{ t().cta_note }}</p>
      </div>
    </div>
  </div>
</section>
